<template>
  <div class="auth-modal-overlay" @click.self="$emit('close')">
    <div class="auth-modal">
      <button class="close-btn" @click="$emit('close')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      
      <div class="auth-tabs">
        <button 
          class="auth-tab" 
          :class="{ active: activeTab === 'login' }"
          @click="activeTab = 'login'"
        >
          {{ $t('Войти') }}
        </button>
        <button 
          class="auth-tab" 
          :class="{ active: activeTab === 'register' }"
          @click="activeTab = 'register'"
        >
          {{ $t('Регистрация') }}
        </button>
      </div>

      <div v-if="activeTab === 'login'" class="auth-form">
        <h2>{{ $t('Войти в аккаунт') }}</h2>
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <input 
              v-model="loginForm.email" 
              type="text" 
              :placeholder="$t('Почта или логин')"
              class="input-field"
            />
            <p v-if="loginErrors.email" class="input-error">{{ loginErrors.email }}</p>
          </div>
          <div class="form-group">
            <div class="password-field">
              <input 
                :type="showLoginPassword ? 'text' : 'password'" 
                v-model="loginForm.password" 
                :placeholder="$t('Пароль')"
                class="input-field"
              />
              <span class="password-toggle" @click="showLoginPassword = !showLoginPassword">
                <img :src="showLoginPassword ? eyeIcon : eyeIconOff" alt="Toggle password" class="eye-icon" />
              </span>
            </div>
            <p v-if="loginErrors.password" class="input-error">{{ loginErrors.password }}</p>
          </div>
          <p v-if="loginErrorMessage" class="error-message">{{ loginErrorMessage }}</p>
          <button type="submit" class="submit-btn" :disabled="loginLoading">
            {{ loginLoading ? $t('Вход...') : $t('Войти') }}
          </button>
        </form>
        <p class="auth-link">
           {{ $t('Нет аккаунта?') }}
           <span @click="activeTab = 'register'">{{ $t('Зарегистрироваться') }}</span>
        </p>
      </div>

      <div v-if="activeTab === 'register'" class="auth-form">
        <h2>{{ $t('Создать аккаунт') }}</h2>
        <form @submit.prevent="handleRegister">
          <div class="form-group">
            <input 
              v-model="registerForm.fullname" 
              type="text" 
                :placeholder="$t('Имя и фамилия')"
              class="input-field"
            />
            <p v-if="registerErrors.fullname" class="input-error">{{ registerErrors.fullname }}</p>
          </div>
          <div class="form-group">
            <input 
              v-model="registerForm.email" 
              type="email" 
                :placeholder="$t('Почта')"
              class="input-field"
            />
            <p v-if="registerErrors.email" class="input-error">{{ registerErrors.email }}</p>
          </div>
          <div class="form-group phone-group">
            <div class="phone-input">
              <div class="country-select">
                <div class="selected-option" @click="toggleDropdown">
                  <template v-if="selectedCountry.flag">
                    <img :src="selectedCountry.flag" alt="" class="flag" />
                    <span class="code">(+{{ selectedCountry.code }})</span>
                  </template>
                  <template v-else>
                    <span class="globe-icon">🌍</span>
                    <span class="code">+</span>
                    <input 
                      type="tel" 
                      v-model="customCountryCode" 
                      @click.stop 
                       :placeholder="$t('код')"
                      class="custom-code-input"
                      maxlength="4"
                    />
                  </template>
                </div>
                <ul v-if="dropdownOpen" class="dropdown">
                  <li v-for="country in countries" :key="country.name" @click="selectCountry(country)" class="dropdown-item">
                    <template v-if="country.flag">
                      <img :src="country.flag" alt="" class="flag" />
                    </template>
                    <template v-else>
                      <span class="globe-icon">🌍</span>
                    </template>
                   <span class="name">{{ $t(country.name) }}</span>
                    <span class="code" v-if="country.code">(+{{ country.code }})</span>
                  </li>
                </ul>
              </div>
              <input 
                type="tel" 
                v-model="registerForm.phone" 
                :placeholder="phonePlaceholder" 
                @input="formatPhoneNumber"
                class="input-field phone-number"
              />
            </div>
            <p v-if="registerErrors.phone" class="input-error">{{ registerErrors.phone }}</p>
          </div>
          <div class="form-group">
            <input 
              v-model="registerForm.username" 
              type="text" 
                :placeholder="$t('Логин')"
              class="input-field"
            />
            <p v-if="registerErrors.username" class="input-error">{{ registerErrors.username }}</p>
          </div>
          <div class="form-group">
            <div class="password-field">
              <input 
                :type="showRegisterPassword ? 'text' : 'password'" 
                v-model="registerForm.password" 
                :placeholder="$t('Пароль')"
                class="input-field"
              />
              <span class="password-toggle" @click="showRegisterPassword = !showRegisterPassword">
                <img :src="showRegisterPassword ? eyeIcon : eyeIconOff" alt="Toggle password" class="eye-icon" />
              </span>
            </div>
            <p v-if="registerErrors.password" class="input-error">{{ registerErrors.password }}</p>
          </div>
          <div class="form-group">
            <div class="password-field">
              <input 
                :type="showRepeatPassword ? 'text' : 'password'" 
                v-model="registerForm.repeat_password" 
                :placeholder="$t('Повторите пароль')"
                class="input-field"
              />
              <span class="password-toggle" @click="showRepeatPassword = !showRepeatPassword">
                <img :src="showRepeatPassword ? eyeIcon : eyeIconOff" alt="Toggle password" class="eye-icon" />
              </span>
            </div>
            <p v-if="registerErrors.repeat_password" class="input-error">{{ registerErrors.repeat_password }}</p>
          </div>
          <div class="form-group checkbox-group">
            <label>
              <input type="checkbox" v-model="registerForm.agreement" class="checkbox" />
              <span>{{ $t('Соглашаюсь с публичной офертой, политикой конфиденциальности и обработкой персональных данных.') }}</span>
            </label>
            <p v-if="registerErrors.agreement" class="input-error">{{ registerErrors.agreement }}</p>
          </div>
          <p v-if="registerErrorMessage" class="error-message">{{ registerErrorMessage }}</p>
          <button type="submit" class="submit-btn" :disabled="registerLoading">
             {{ registerLoading ? $t('Регистрация...') : $t('Создать аккаунт') }}
          </button>
        </form>
        <p class="auth-link">
           {{ $t('Уже есть аккаунт?') }}
           <span @click="activeTab = 'login'">{{ $t('Войти') }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import belarusIcon from '@/assets/images/auth/flags/icon-belarus.png';
import kyrgyzstanIcon from '@/assets/images/auth/flags/icon-kyrgyzstan.png';
import russiaIcon from '@/assets/images/auth/flags/icon-russia.png';
import thailandIcon from '@/assets/images/auth/flags/icon-thailand.png';
import ukraineIcon from '@/assets/images/auth/flags/icon-ukraine.png';
import eyeIcon from '@/assets/images/auth/eye_icon.svg';
import eyeIconOff from '@/assets/images/auth/eye_icon_off.svg';
import { mapActions } from 'vuex';
import store from '@/store';

export default {
  name: 'AuthModal',
  emits: ['close', 'success'],
  data() {
    return {
      activeTab: 'register',
      loginForm: {
        email: '',
        password: '',
      },
      registerForm: {
        fullname: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        repeat_password: '',
        agreement: false,
      },
      loginErrors: {},
      registerErrors: {},
      loginErrorMessage: '',
      registerErrorMessage: '',
      loginLoading: false,
      registerLoading: false,
      showLoginPassword: false,
      showRegisterPassword: false,
      showRepeatPassword: false,
      dropdownOpen: false,
      customCountryCode: '',
      selectedCountry: { name: 'Россия', code: '7', flag: russiaIcon },
      countries: [
        { name: 'Россия', code: '7', flag: russiaIcon, pattern: /^(\d{3})(\d{3})(\d{2})(\d{2})$/, format: '($1) $2-$3-$4', maxLength: 10 },
        { name: 'Украина', code: '380', flag: ukraineIcon, pattern: /^(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '($1) $2-$3-$4', maxLength: 9 },
        { name: 'Кыргызстан', code: '996', flag: kyrgyzstanIcon, pattern: /^(\d{3})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4', maxLength: 9 },
        { name: 'Беларусь', code: '375', flag: belarusIcon, pattern: /^(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '($1) $2-$3-$4', maxLength: 9 },
        { name: 'Тайланд', code: '66', flag: thailandIcon, pattern: /^(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3', maxLength: 9 },
        { name: 'Другая страна', code: '', flag: null, pattern: null, format: null, maxLength: 15 },
      ],
      eyeIcon,
      eyeIconOff,
    };
  },
  computed: {
    phonePlaceholder() {
      switch (this.selectedCountry.code) {
        case '7': return '(495) 231-36-60';
        case '380': return '(44) 278-13-57';
        case '996': return '312 97 61 61';
        case '375': return '(17) 327-45-62';
        case '66': return '8 1234 5678';
        default: return this.$t('Номер телефона');
      }
    },
    currentCountryConfig() {
      const config = this.countries.find(country => country.code === this.selectedCountry.code);
      if (!config) {
        return this.countries.find(country => country.name === 'Другая страна');
      }
      return config;
    },
    isCustomCountry() {
      return !this.selectedCountry.flag;
    }
  },
  methods: {
    ...mapActions('auth', ['login', 'register']),
    
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    
    selectCountry(country) {
      this.selectedCountry = country;
      this.dropdownOpen = false;
      this.registerForm.phone = '';
    },
    
    formatPhoneNumber() {
      let digits = this.registerForm.phone.replace(/\D/g, '');
      const config = this.currentCountryConfig;
      const maxLength = config ? config.maxLength : 15;
      if (digits.length > maxLength) {
        digits = digits.substring(0, maxLength);
      }
      if (config && config.pattern && config.pattern.test(digits)) {
        this.registerForm.phone = digits.replace(config.pattern, config.format);
      } else {
        this.registerForm.phone = digits;
      }
    },
    
    async handleLogin() {
      this.loginErrors = {};
      this.loginErrorMessage = '';
      this.loginLoading = true;
      
      try {
        const response = await this.login(this.loginForm);
        if (store.getters['auth/loginSuccess']) {
          if (!store.state.auth.user) {
            await store.dispatch('auth/loadUser');
            await store.dispatch('ui/initAvatarSrcFromUser');
          }
          this.$emit('success');
        } else {
          if (response && response.errors) {
            this.loginErrorMessage = this.$t(response.errors.title || 'auth.loginError');
            if (response.errors.details) {
              Object.keys(response.errors.details).forEach((field) => {
                this.loginErrors[field] = this.$t(response.errors.details[field][0]);
              });
            }
          } else {
            this.loginErrorMessage = this.$t('auth.loginError');
          }
        }
      } catch (error) {
        this.loginErrorMessage = this.$t('auth.loginError');
      } finally {
        this.loginLoading = false;
      }
    },
    
    async handleRegister() {
      this.registerErrors = {};
      this.registerErrorMessage = '';
      this.registerLoading = true;
      
      try {
        const phoneDigits = this.registerForm.phone.replace(/\D/g, '');
        const countryCode = this.isCustomCountry ? this.customCountryCode : this.selectedCountry.code;
        const phoneForApi = countryCode ? `+${countryCode}${phoneDigits}` : `+${phoneDigits}`;
        
        const formData = {
          ...this.registerForm,
          phone: phoneForApi
        };
        
        const response = await this.register(formData);
        if (store.getters['auth/registrationSuccess']) {
          await this.login({
            email: this.registerForm.email,
            password: this.registerForm.password
          });
          if (store.getters['auth/loginSuccess']) {
            if (!store.state.auth.user) {
              await store.dispatch('auth/loadUser');
              await store.dispatch('ui/initAvatarSrcFromUser');
            }
            this.$emit('success');
          }
        } else {
          if (response && response.errors) {
            this.registerErrorMessage = this.$t(response.errors.title || 'auth.registerError');
            if (response.errors.details) {
              Object.keys(response.errors.details).forEach((field) => {
                this.registerErrors[field] = this.$t(response.errors.details[field][0]);
              });
            }
          } else {
            this.registerErrorMessage = this.$t('auth.registerError');
          }
        }
      } catch (error) {
        this.registerErrorMessage = this.$t('auth.registerError');
      } finally {
        this.registerLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.auth-modal {
  background: #fff;
  border-radius: 24px;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #333;
}

.auth-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 30px;
}

.auth-tab {
  flex: 1;
  padding: 12px 20px;
  border: none;
  background: #f5f5f5;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
}

.auth-tab.active {
  background: linear-gradient(135deg, #496782 0%, #26374e 100%);
  color: #fff;
}

.auth-form h2 {
  font-size: 24px;
  font-weight: 600;
  color: #26374e;
  margin-bottom: 24px;
  text-align: center;
}

.form-group {
  margin-bottom: 16px;
  position: relative;
}

.input-field {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.input-field:focus {
  outline: none;
  border-color: #496782;
}

.password-field {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.eye-icon {
  width: 20px;
  height: 20px;
  opacity: 0.5;
}

.input-error {
  color: #e74c3c;
  font-size: 12px;
  margin-top: 4px;
}

.error-message {
  color: #e74c3c;
  font-size: 14px;
  text-align: center;
  margin-bottom: 16px;
}

.checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.checkbox-group label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
}

.checkbox {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #496782 0%, #26374e 100%);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 8px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(73, 103, 130, 0.4);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.auth-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.auth-link span {
  color: #496782;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;
}

.auth-link span:hover {
  color: #26374e;
}

.phone-group .phone-input {
  display: flex;
  gap: 0;
}

.country-select {
  position: relative;
  min-width: 110px;
}

.selected-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 12px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 12px 0 0 12px;
  cursor: pointer;
  height: 48px;
  box-sizing: border-box;
}

.flag {
  width: 24px;
  height: auto;
}

.code {
  font-size: 13px;
  color: #666;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  list-style: none;
  padding: 8px 0;
  margin: 4px 0 0 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background: #f5f5f5;
}

.dropdown-item .name {
  flex: 1;
  font-size: 13px;
}

.phone-number {
  flex: 1;
  border-radius: 0 12px 12px 0 !important;
}

.globe-icon {
  font-size: 20px;
}

.custom-code-input {
  width: 40px;
  border: none;
  background: transparent;
  font-size: 13px;
  padding: 0;
}

.custom-code-input:focus {
  outline: none;
}

@media (max-width: 480px) {
  .auth-modal {
    padding: 24px;
    border-radius: 16px;
  }
  
  .auth-form h2 {
    font-size: 20px;
  }
}
</style>
